/* global globalThis */
import React, {useContext, useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useHistory, useLocation} from "react-router-dom";
import {LAST_QUERY_USAGE_KEY} from "../patientProfile/PatientProfileHeader";
import {Helmet} from 'react-helmet';
import {Badge, Button, Card, Col, Container, Dropdown, DropdownButton, Row, Spinner} from "react-bootstrap";
import ExportSummary from "./ExportSummary";
import ListView from "./components/patientList";
import CustomPagination from "../common/CustomPaginaton";
import {
    cancelRequest,
    deleteUserWorklist,
    removePatientsFromList,
    searchPatientMain,
} from "../../actions/patientSearch/patientSearchActions";
import {removeQuicklistById} from "../../actions/navigation/navigationActions";
import {useDispatch} from "react-redux";
import {FilterParam, PatientSearchDTO,} from "../../dtos/PatientSearchDTO";
import axios from "../../utils/apiClient";
import Modals from "../../components/modals";
import {
    formatDate,
    getCustomListName,
    getCustomWorklistName,
    getPatientProfileLink,
    getQuickListId,
    preventiveCarePatientFilterParams
} from "../../utils/util";
import ShareWorklist from "./ShareWorklist";
import _ from "lodash";
import {SessionStorageUtil} from "../../utils/localStorageUtil";
import {QuickListContext} from "./QuickListContext";
import {CE_RESTORE_OBJ} from "../common/MainLayout";
import AssignCareManagerModal from "../caremgmt/AssignCareManagerModal";
import {assignCareManager} from "../../actions/caremgmt/hubWorkCenterAction";
import CustomFilterList from "./CustomFilterList";
import UpdateCustomFilterList from "./../../views/quickList/UpdateCustomFilterList";
import WeekFilter from "./weekFilter";
import ScheduleListView from "./components/ScheduleList";
import {FilterGroupNew} from "../../components/filters/filterGroupNew";
import cloneDeep from "lodash/cloneDeep";
import {getErrorCode, TRACK_EVENTS, trackPendoEvent} from "../../utils/pendoTrack";

const componentName = "QuickListNew";
const isEmpty = require("is-empty");

export const PRINT_URL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-card/print`;
export const PRINT_SYNC_URL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-card/print-sync`;
export const EXPORT_URL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-card/export`;
export const SUMMARY_URL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/patient-card/export-summary`;
export const CUSTOM_LIST_URL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/custom-filtered-list/custom-lists`;
export const WORKLIST_URL = `${process.env.REACT_APP_REST_API_BASE_URL}/v1/custom-work-list/work-list`;
const LAST_QUERY_SETTINGS_SUFFIX = `-QLQuerySettings`;
const RECENT_QUERY_SETTINGS_KEY = `ce-recent-query-settings-key`;

const pathName = globalThis.location.pathname;
const modifiedPathName = pathName.endsWith("/") ? pathName.substring(0, pathName.length - 1) : pathName;
export const RETURN_TO_MY_PATIENTS_URL = encodeURIComponent(
  "returnTo_" + modifiedPathName + "?loadLastQuerySettings=true"
);

const RemoveModalBody = ({ patientsSelected }) => {
  const location = useLocation();

  return (
    <div>
      <p>You have selected {patientsSelected.length} member
        {patientsSelected.length > 1 && "s"} to remove from your organiazation's
        patient list.</p>
      <p>Would you like to proceed?</p>
      {patientsSelected.map((patient) => (
        <a key={patient.id} className="nav-link pt-0 pb-0" href={getPatientProfileLink(patient.id, location, "PreventiveCare")}>
          {patient.lastName}, {patient.firstName}
        </a>
      ))}
    </div>
  );
};

RemoveModalBody.propTypes = {
  patientsSelected: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      lastName: PropTypes.string,
    })
  ).isRequired,
};

const ConfirmWorklistDeletion = ({
  showConfirmation,
  setConfirmation,
  id,
  customListDto,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  let modalTitle = "Delete Custom List";
  let modalMessage = "Are you sure you want to delete this custom list?";

  const handleWorklistDeletion = async () => {
    await deleteUserWorklist(id);
    let listId = null;
    if (customListDto) {
      listId = "/" + customListDto.quickList.toLowerCase() + "?id=" + id;
    }
    dispatch(removeQuicklistById(listId));
    setConfirmation(false);
    history.push("/all_patients/");
  };

  return (
    <Modals
      show={showConfirmation}
      onHide={() => setConfirmation(false)}
      title={modalTitle}
      size="md"
      onCreate={handleWorklistDeletion}
      hideClickButton={false}
      showExtraButton={false}
      hideFooter={false}
      completeBtn="Delete"
      completeBtnId={`${componentName}-deleteButton`}
      body={<div>{modalMessage}</div>}
    />
  );
};

ConfirmWorklistDeletion.propTypes = {
  customListDto: PropTypes.shape({
    quickList: PropTypes.string,
  }),
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setConfirmation: PropTypes.func.isRequired,
  showConfirmation: PropTypes.bool.isRequired,
};

const VIEW = { card: "CARD", list: "LIST" };

const getReturnToMyPatientsUrl = (workingPathName, quicklistId, customListName) => {
  if (quicklistId && !Number.isNaN(Number(quicklistId))) {
    return encodeURIComponent(
      "returnTo_" +
      workingPathName +
      encodeURIComponent("?loadLastQuerySettings=true&id=" + quicklistId + "&customListName=" + customListName)
    );
  }

  return encodeURIComponent("returnTo_" + workingPathName + "?loadLastQuerySettings=true");
};

const createPatientListSection = (defaultPatients) => ({
  default: defaultPatients,
  scheduledPatients: [],
  unScheduledPatients: [],
  unableToContact: [],
  patientRefused: [],
  leftMessage: [],
  changedPCP: [],
});

const QuickListNew = ({
  titleProp,
  filters,
  pageNumberProp,
  pageSizeProp,
  totalSizeProp,
  defaultFilterParamsProp,
  defaultSortParamsProp,
  quickListType,
  displayExtraRows,
  quickListId,
  cardViewActionObj = {
    fetchData: searchPatientMain,
    copyMap: {
      list: "patientCardDtos",
      totalSize: "totalSize",
      pageSize: "pageSize",
      pageNumber: "pageNumber",
    },
  },
  listViewActionObj,
  startingView = VIEW.card,
  listViewColumns,
  children,
  careManagementActions,
  onCareManagerAssigmentError,
  careManagerPrograms,
  careManagerTeams,
  showCount = false
}) => {
  const qlsSettings = useContext(QuickListContext);
  const quicklistId = getQuickListId();
  const customWorklistName = getCustomWorklistName();
  const customListName = getCustomListName();
  const [returnToMyPatientsUrl, setReturnToMyPatientsUrl] = useState(RETURN_TO_MY_PATIENTS_URL);

  useEffect(() => {
    const location = globalThis.location.pathname;
    const workingPathName = location.endsWith("/")
      ? location.substring(0, location.length - 1)
      : location;
    setReturnToMyPatientsUrl(getReturnToMyPatientsUrl(workingPathName, quicklistId, customListName));
  }, [quickListType, quicklistId, customListName]);
  const [initialParam] = useState(cloneDeep(defaultFilterParamsProp))
  const [selectedPatients, setSelectedPatients] = useState(new Map());
  const [title, setTitle] = useState(titleProp);
  const [patientsList, setPatientsList] = useState({
    default: [],
    weekView: []
  });
  const [cardViewData, setCardViewData] = useState({});
  const [listViewData, setListViewData] = useState({});
  const [pageNumber, setPageNumber] = useState(pageNumberProp);
  const [pageSize, setPageSize] = useState(pageSizeProp);
  const [totalSize, setTotalSize] = useState(totalSizeProp);


  const [scheduledPatientSize] = useState({});
  const [unScheduledPatientSize] = useState({});
  const [unableToContactPatientSize] = useState({})
  const [patientRefusedPatientSize] = useState({});
  const [leftMessagePatientSize] = useState({});
  const [changedPCPPatientSize] = useState({});
  const [loadingData, setLoadingData] = useState(true);
  const [listViewLoadingData, setListViewLoadingData] = useState(!!listViewActionObj);

  const [defaultFilterParams, setDefaultFilterParams] = useState(
    defaultFilterParamsProp
  );
  const [filterParams, setFilterParams] = useState(defaultFilterParamsProp);
  const [customListDto, setCustomListDto] = useState(null);
  const [sortParams, setSortParams] = useState([]);
  const [modalMessage, setModalMessage] = useState(null);
  const [removeModal, setRemoveModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [filterButtons, setFilterButtons] = useState(false);
  const [modalSize, setModalSize] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [showPrintSpinner, setShowPrintSpinner] = useState(false);
  const [showExportSpinner, setShowExportSpinner] = useState(false);
  const [view, setView] = useState(startingView);
  const [showAssignCareManagerModal, setShowAssignCareManagerModal] = useState(false);
  const [patientIds, setPatientIds] = useState(null);
  const [showCustomFilterList, setShowCustomFilterList] = useState(false);
  const [showUpdateCustomFilterList, setShowUpdateCustomFilterList] = useState(false);
  const [selectedName, setSelectedName] = useState('');
  const [canceled, setCanceled] = useState(false);
  const [weekFilterApplied, setWeekFilterApplied] = useState(false);
  const [filterDates, setFilterDates] = useState([]);
  const [resetDefault, setResetDefault] = useState(false);
  const [scheduleFilterApplied, setScheduleFilterApplied] = useState(false);

  const LAST_QUERY_SETTINGS_KEY = `${quickListType}` + LAST_QUERY_SETTINGS_SUFFIX;

  const setDefaultFilterParamHelper = (filterParams) => {
    setDefaultFilterParams(defaultFilterParamsProp);
    setFilterParams(filterParams);
  };

  const getScheduleAwareFilterParams = (incomingFilterParams) => {
    if (incomingFilterParams.some(param => param.paramName !== 'schedule')) {
      setWeekFilterApplied(false);
      setFilterDates("");
      const copyParams = cloneDeep(initialParam);
      copyParams[0].paramValue = ["APPOINTMENT_SCHEDULED"];
      for (const filterParam of incomingFilterParams) {
        if (filterParam.paramName !== 'schedule') {
          copyParams.push(filterParam);
        }
      }
      return copyParams;
    }

    setResetDefault(true);
    return cloneDeep(initialParam);
  };

  const trackFilterChange = (filterParams) => {
    if (filterParams.length > 0) {
      trackPendoEvent(TRACK_EVENTS.NAV_FILTER_APPLIED, {
        route: globalThis.location?.pathname,
        quicklist_type: quickListType,
        filter_name: filterParams.map((param) => param?.paramName).filter(Boolean).join(","),
        source_module: "QuickListNew.handleFilterChange"
      });
      return;
    }

    trackPendoEvent(TRACK_EVENTS.NAV_FILTER_CLEARED_ALL, {
      route: globalThis.location?.pathname,
      quicklist_type: quickListType,
      source_module: "QuickListNew.handleFilterChange"
    });
  };

  const handleFilterChange = (filterParams, p) => {
    cancelRequest(setCanceled);
    const nextFilterParams = getScheduleAwareFilterParams(filterParams);
    trackFilterChange(nextFilterParams);
    setFilterParams(nextFilterParams);
    setSelectedPatients(new Map());
    const nextPage = p || 1;
    query(
      new PatientSearchDTO(
        nextFilterParams,
        sortParams,
        nextPage,
        pageSize,
        quickListType,
        totalSize
      ),
      title,
      view
    );
  };

  const handleFilterPageSize = (e) => {
    const result = e.target.value.split("-");
    query(
      new PatientSearchDTO(
        filterParams,
        sortParams,
        1,
        result[0],
        quickListType,
        totalSize
      ),
      title,
      view
    );

  };
  const handlePaginationChange = (pageNumber) => {
    setPageNumber(pageNumber);
    if (weekFilterApplied && !scheduleFilterApplied) {
      handleFilterDatesResult(pageNumber);
    }
    else {
      query(
        new PatientSearchDTO(
          filterParams,
          sortParams,
          pageNumber,
          pageSize,
          quickListType,
          totalSize
        ),
        title,
        view
      );
    }
  };

  let pageObject = {
    pageNumber: 0,
    data: {},
    weekView: []
  };

  const getPatientListCopyMap = (inView = view) => {
    if (inView === VIEW.list && listViewActionObj) {
      return listViewActionObj.copyMap;
    }

    return cardViewActionObj.copyMap;
  };

  const buildWeekPatientListSection = (weekView, copyMap) => {
    const dateGroup = [];
    let maxTotalSize = 0;
    let maxPageSize = 0;
    if (!isEmpty(weekView)) {
      for (const weekViewItem of weekView) {
        const itemTotalSize = _.get(weekViewItem.data, copyMap["totalSize"]);
        const itemPageSize = _.get(weekViewItem.data, copyMap["pageSize"]);
        maxTotalSize = Math.max(maxTotalSize, itemTotalSize);
        maxPageSize = Math.max(maxPageSize, itemPageSize);
        dateGroup.push({
          date: weekViewItem.date,
          data: _.get(weekViewItem.data, copyMap["list"]),
          totalSize: itemTotalSize,
        });
      }
    }

    return { dateGroup, maxPageSize, maxTotalSize };
  };

  const copyToPatientListVariables = (data, weekView, inView) => {
    const copyMap = getPatientListCopyMap(inView);
    const patientListSectioned = {
      default: [],
      weekView: []
    };
    if (weekFilterApplied && !scheduleFilterApplied) {
      const { dateGroup, maxPageSize, maxTotalSize } = buildWeekPatientListSection(weekView, copyMap);
      setTotalSize(maxTotalSize);
      setPageSize(maxPageSize);
      patientListSectioned.weekView = dateGroup;
    } else {
      setTotalSize(_.get(data, copyMap["totalSize"]));
      setPageSize(_.get(data, copyMap["pageSize"]));
      patientListSectioned.default = _.get(data, copyMap["list"]);
    }
    setPatientsList(patientListSectioned);
  };

  useEffect(() => {
    setSelectedPatients(new Map());
    if (!isEmpty(filterDates)) {
      setPageNumber(1);
      handleFilterDatesResult(1);
    }
  // Date filtering intentionally drives this effect; widening deps triggers duplicate queries.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDates]);

  useEffect(() => {
    if (cardViewData && cardViewData.pageNumber === pageNumber) {
      if (!listViewActionObj) {
        setListViewData(cardViewData);
        copyToPatientListVariables(
          cardViewData.data
          , cardViewData.weekView
        );
      } else if (listViewActionObj && view === VIEW.card) {
        copyToPatientListVariables(
          cardViewData.data
          , cardViewData.weekView
        );
      }
      setLoadingData(false);
    }
  // Card response hydration is intentionally keyed to the response payload only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardViewData]);

  useEffect(() => {
    if (listViewActionObj && listViewData && listViewData.pageNumber === pageNumber) {
      if (view === VIEW.list) {
        copyToPatientListVariables(listViewData.data);
      }
      setListViewLoadingData(false);
    }
  // List response hydration is intentionally keyed to the response payload only.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listViewData]);

  const handleFilterDatesResult = async (pageNumber) => {
    if ((!isEmpty(filterDates)) && filterDates[0] !== 'defaultView') {
      for (const date of filterDates) {
        for (const filterParam of filterParams) {
          if (filterParam.paramName === 'schedule') {
            filterParam.paramValue = ["APPOINTMENT_SCHEDULED", date];
          }
        }
        await query(new PatientSearchDTO(filterParams,
          sortParams,
          pageNumber,
          20,
          quickListType,
          totalSize
        ),
          title,
          view,
          date
        );
      }
      setCardViewData(pageObject);
    }
    else {
      fetchData(initialParam, quickListType, titleProp, VIEW.card, true);
    }
  };
  const query = async (patientSearchDTO, updatedTitle, updatedView, date) => {
    setResetDefault(false); //clear flag
    setLoadingData(true);
    setPageNumber(patientSearchDTO.pageNumber);
    SessionStorageUtil.setObj(RECENT_QUERY_SETTINGS_KEY, LAST_QUERY_SETTINGS_KEY);
    SessionStorageUtil.setObj(LAST_QUERY_SETTINGS_KEY, {
      patientSearchDTO: patientSearchDTO,
      view: updatedView,
      title: updatedTitle,
    });
    if (listViewActionObj) {
      setListViewLoadingData(true);
    }
    await cardViewActionObj
      .fetchData(patientSearchDTO)
      .then((res) => {
        if (res.data) {
          if ((!isEmpty(filterDates)) && filterDates[0] !== 'defaultView' && patientSearchDTO.filterParams.length === 1) {
            const groupObject = {
              date: date,
              data: res.data
            };
            pageObject.pageNumber = patientSearchDTO.pageNumber;
            pageObject.weekView.push(groupObject);
          } else {
            pageObject = {
              pageNumber: patientSearchDTO.pageNumber,
              data: res.data
            };
            setCardViewData(pageObject);
          }
        }
        setCanceled(false)
      })
      .catch((err) => {
        if (err?.message !== 'cancel by user') {
          setCanceled(false)
        }
        setLoadingData(false);
      });

    if (listViewActionObj) {
      listViewActionObj
        .fetchData(patientSearchDTO)
        .then((res) => {
          if (res.data) {
            const pageObject = {
              pageNumber: patientSearchDTO.pageNumber,
              data: res.data
            };
            setListViewData(pageObject);
          }
          setCanceled(false)
        })
        .catch((err) => {
          if (err?.message !== 'cancel by user') {
            setCanceled(false)
          }
          setListViewLoadingData(false);
        });
    }
  };
  const fetchData = async (filterParams, quicklistName, title, view, reloadTodayFromSchedule) => {
    let dto = new PatientSearchDTO(
      filterParams,
      sortParams,
      pageNumber,
      pageSize,
      quicklistName
    )
    if (reloadTodayFromSchedule) {
      dto = new PatientSearchDTO(
        filterParams,
        sortParams,
        1,
        20,
        quicklistName
      )
    }

    query(
      dto,
      title,
      view
    );
  };

  const getSavedQuickListState = () => {
    const restoreObject = SessionStorageUtil.getObj(CE_RESTORE_OBJ);
    let quicklistObj = SessionStorageUtil.getObj(LAST_QUERY_SETTINGS_KEY);
    const useLastQuery = SessionStorageUtil.getObj(LAST_QUERY_USAGE_KEY);
    SessionStorageUtil.setObj(LAST_QUERY_USAGE_KEY, null);
    if (restoreObject) {
      if (restoreObject.recentKey === LAST_QUERY_SETTINGS_KEY) {
        quicklistObj = restoreObject.quickListObj;
        SessionStorageUtil.setObj(LAST_QUERY_SETTINGS_KEY, quicklistObj);
      }
      SessionStorageUtil.setObj(CE_RESTORE_OBJ, null);
    }

    return { quicklistObj, restoreObject, useLastQuery };
  };

  const loadSavedQuickList = (quicklistObj) => {
    if (defaultSortParamsProp) {
      quicklistObj.patientSearchDTO.sortParams = defaultSortParamsProp;
    }
    setTitle(quicklistObj.title);
    setView(quicklistObj.view);
    setFilterButtons(quicklistId && !Number.isNaN(Number(quicklistId)));
    setDefaultFilterParamHelper(quicklistObj.patientSearchDTO.filterParams);
    setSortParams(quicklistObj.patientSearchDTO.sortParams);
    query(
      quicklistObj.patientSearchDTO,
      quicklistObj.title,
      quicklistObj.view
    );
  };

  const loadCustomList = () => {
    axios
      .get(CUSTOM_LIST_URL + "?id=" + quicklistId, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setFilterButtons(true);
        setDefaultFilterParamHelper(
          response.data.patientRequestDTO.filterParams
        );
        setTitle(response.data.name);
        fetchData(
          response.data.patientRequestDTO.filterParams,
          response.data.quickList,
          response.data.name,
          view,
        );
        setCustomListDto(response.data);
      })
      .catch((error) => {
        setModalTitle("Error");
        setModalSize("lg");
        setModalMessage(error.response?.data?.message || error.message);
        setLoadingData(false);
      });
  };

  const loadCustomWorklist = () => {
    axios
      .get(WORKLIST_URL + "?id=" + quicklistId, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setCustomListDto(response.data);
      })
      .catch(() => {
        setLoadingData(false);
      });

    setFilterButtons(true);
    const valuesAndDisplayValues = [{
      text: customWorklistName,
      value: quicklistId,
    }];

    const filterParam = new FilterParam(
      "Member Worklist",
      "eq",
      valuesAndDisplayValues,
      (x) => x.value,
      (x) => x.text
    );
    const tempFilterParams = Object.assign([], filterParams);
    tempFilterParams.push(filterParam);
    setDefaultFilterParamHelper(tempFilterParams);
    setTitle(customWorklistName);
    fetchData(tempFilterParams, "ALL_PATIENTS", customWorklistName, view);
    setFilterParams(tempFilterParams);
  };

  const loadPatientOverview = () => {
    const patientFilters = preventiveCarePatientFilterParams;
    axios
      .get(
        process.env.REACT_APP_REST_API_BASE_URL +
        `/v1/patients/overview/summary?patientId=${quicklistId}`,
        {
          headers: {},
        }
      )
      .then((response) => {
        patientFilters[0].displayValue[0] = response.data.lastName;
        patientFilters[0].displayValue[1] = response.data.firstName;
        patientFilters[0].paramValue[0] =
          response.data.lastName + ", " + response.data.firstName;
        patientFilters[1].displayValue[0] =
          "On " + formatDate(response.data.dateOfBirth);
        patientFilters[1].paramValue[0] = formatDate(
          response.data.dateOfBirth
        );

        setFilterButtons(true);
        setDefaultFilterParamHelper(patientFilters);
        setTitle(titleProp);
        fetchData(patientFilters, quickListType, titleProp, view);
      })
      .catch(() => {
        setLoadingData(false);
      });
  };

  const loadDefaultQuickList = () => {
    setTitle(titleProp);
    setDefaultFilterParamHelper(defaultFilterParamsProp);
    setFilterButtons(false);

    if (defaultSortParamsProp) {
      setSortParams(defaultSortParamsProp);
      query(
        new PatientSearchDTO(
          defaultFilterParamsProp,
          defaultSortParamsProp,
          pageNumber,
          pageSize,
          quickListType
        ),
        titleProp,
        view,
      );
      return;
    }

    fetchData(defaultFilterParamsProp, quickListType, titleProp, view);
  };

  useEffect(() => {
    const { quicklistObj, restoreObject, useLastQuery } = getSavedQuickListState();
    if ((restoreObject || useLastQuery) && quicklistObj?.patientSearchDTO) {
      loadSavedQuickList(quicklistObj);
    } else if (quicklistId && !Number.isNaN(Number(quicklistId))) {
      loadCustomList();
    } else if (quicklistId?.includes("customWorklist")) {
      loadCustomWorklist();
    } else if (quicklistId?.includes("data")) {
      loadPatientOverview();
    } else {
      loadDefaultQuickList();
    }
  // Initial quick-list routing is intentionally keyed to the route quicklist id.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quicklistId]);

  const reloadPatientView = () => {
    fetchData(filterParams, quickListType, titleProp, view);
  };

  const getPatientSelectionKey = (patient) => {
    if (!patient) return null;

    const stringifyPatientKey = (patient) => {
      const seen = new WeakSet();
      return JSON.stringify(patient, (key, value) => {
        if (typeof value !== "object" || value === null) {
          return value;
        }
        if (seen.has(value)) {
          return "[Circular]";
        }
        seen.add(value);
        return value;
      });
    };

    const instanceKey = normalizeIdValue(patient.selectionInstanceKey);
    if (instanceKey) {
      return instanceKey;
    }

    const baseId =
      normalizeIdValue(patient.id) ??
      normalizeIdValue(patient.patientId) ??
      normalizeIdValue(patient.patientID) ??
      normalizeIdValue(patient.memberId) ??
      null;

    const gapId =
      normalizeIdValue(patient.careGapId) ??
      normalizeIdValue(patient.careGapID) ??
      normalizeIdValue(patient.patientGapId) ??
      normalizeIdValue(patient.patientGapID) ??
      normalizeIdValue(patient.visitGapId) ??
      normalizeIdValue(patient.visitGapID) ??
      normalizeIdValue(patient.visitId) ??
      normalizeIdValue(patient.visitID) ??
      normalizeIdValue(patient.gapId) ??
      normalizeIdValue(patient.gapID) ??
      normalizeIdValue(patient.worklistItemId) ??
      normalizeIdValue(patient.worklistItemID) ??
      null;

    if (baseId && gapId) {
      return `${baseId}|${gapId}`;
    }

    if (baseId) {
      return baseId;
    }

    if (gapId) {
      return `gap|${gapId}`;
    }

    return stringifyPatientKey(patient);
  };

  const getPatientSelectionBaseKey = (patient) => {
    if (!patient) return null;
    const patientCopy = { ...patient };
    delete patientCopy.selectionInstanceKey;
    return getPatientSelectionKey(patientCopy);
  };

  const applyPatientSelection = (selectedPatientsMap, patient, selected) => {
    const key = getPatientSelectionKey(patient);
    if (!key) return;

    if (selected) {
      selectedPatientsMap.set(key, patient);
    } else {
      selectedPatientsMap.delete(key);
    }

    const baseKey = getPatientSelectionBaseKey(patient);
    if (baseKey && baseKey !== key) {
      selectedPatientsMap.delete(baseKey);
    }
  };

  const selectPatient = (patient, selected) => {
    const selectedPatientsCopy = new Map(selectedPatients);
    applyPatientSelection(selectedPatientsCopy, patient, selected);
    setSelectedPatients(selectedPatientsCopy);
    if (selected) {
      trackPendoEvent(TRACK_EVENTS.QUICKLIST_PATIENT_SELECTED, {
        route: globalThis.location?.pathname,
        quicklist_type: quickListType,
        selection_mode: "single",
        source_module: "QuickListNew.selectPatient"
      });
    }
  };
  const selectPatients = (patients, selected) => {
    const selectedPatientsCopy = new Map(selectedPatients);
    for (const patient of patients) {
      applyPatientSelection(selectedPatientsCopy, patient, selected);
    }
    setSelectedPatients(selectedPatientsCopy);
    if (selected) {
      trackPendoEvent(TRACK_EVENTS.QUICKLIST_PATIENT_SELECTED, {
        route: globalThis.location?.pathname,
        quicklist_type: quickListType,
        selection_mode: "bulk",
        source_module: "QuickListNew.selectPatients"
      });
    }
  };
  const isPatientSelected = (patient) => {
    const key = getPatientSelectionKey(patient);
    if (!key) return false;
    if (selectedPatients.has(key)) {
      return true;
    }
    const baseKey = getPatientSelectionBaseKey(patient);
    return baseKey ? selectedPatients.has(baseKey) : false;
  };

  const removePatients = async () => {
    const patientIds = buildUniquePatientIds();
    await removePatientsFromList(patientIds);
    setRemoveModal(false);
    query(
      new PatientSearchDTO(
        filterParams,
        sortParams,
        pageNumber,
        pageSize,
        quickListType
      ),
      title,
      view
    );
  };

  const closeEvidenceModal = () => {
    query(
      new PatientSearchDTO(
        filterParams,
        sortParams,
        pageNumber,
        pageSize,
        quickListType
      ),
      title,
      view
    );
  };

  const updateParent = (updatedRef, sourceType) => {
    let newState = patientsList.default;
    if (sourceType && sourceType === "ManageEvidence") {
      return;
    } else if (sourceType && sourceType === "SubmitRecentVisit") {
      newState.forEach((pat, patI) => {
        if (pat.id === updatedRef.patientId) {
          newState[patI].nextVisit = updatedRef.nextVisit;
          newState[patI].recentVisitStatus = updatedRef.recentVisitStatus;
          newState[patI].nextVisitInfo = updatedRef.nextVisitInfoDesc;
          newState[patI].recentVisit = updatedRef.recentVisit;
          newState[patI].recentVisitInfo = updatedRef.recentVisitInfoDesc;
          setPatientsList(createPatientListSection([...newState]));
        }
      });
    } else if (updatedRef) {
      let patIndex = null;
      let refIndex = null;
      newState.forEach((pat, patI) => {
        if (pat.id === updatedRef.patient.id) {
          patIndex = patI;
          pat.referralDtoList.forEach((ref, refI) => {
            if (ref.id === updatedRef.referralId) {
              refIndex = refI;
            }
          });
        }
      });
      if (
        newState[patIndex].referralDtoList[refIndex].status !==
        updatedRef.status
      ) {
        newState[patIndex].referralDtoList[refIndex].status = updatedRef.status;
        setPatientsList(createPatientListSection([...newState]));
      }
    }
  };


  const onShowAssignCareManagerModal = (patientIds) => {
    setShowAssignCareManagerModal(true)
    setPatientIds(patientIds)
  }

  const bulkCareManagerAssignment = () => {
    if (selectedPatients.size) {
      setSelectedName('')
      setShowAssignCareManagerModal(true)
      const patientIds = buildUniquePatientIds();
      setPatientIds(patientIds)
    }
  }

  const assignToCareManager = (assignment) => {
    const payload = patientIds.map(patientId => {
      return { ...assignment, patientId, origin: 'CARE_EMPOWER_REFERRALS' }
    });
    assignCareManager(payload)
      .then(() => {
        setSelectedPatients(new Map())
        setShowAssignCareManagerModal(false)
        reloadPatientView()
      })
      .catch(error => {
        onCareManagerAssigmentError(error)
        setShowAssignCareManagerModal(false)
      })
  }

  const getCurrentFilters = () => {
    let filterView = [];
    for (const filter of filters) {
      let filterValue = "";
      for (const filterParam of filterParams) {
        if (filter.getKey() === filterParam.paramName) {
          if (filterParam.paramValue.length > 1) {
            filterValue = "Multiple";
          } else if (filterParam.displayValue?.[0] == null) {
            filterValue = getFilterValue(filterParam.paramValue[0]);
          } else {
            filterValue = getFilterValue(filterParam.displayValue[0]);
          }
          break;
        }
      }
      if (filterValue === "") {
        filterValue = "All";
      }
      filterView.push({
        filterName: filter.getHeader(),
        filterValue: filterValue,
      });
    }
    return filterView;
  };
  const getFilterValue = (values) => {
    let filterValue = "";
    if (Array.isArray(values)) {
      for (const value of values) {
        if (filterValue !== "") {
          filterValue = filterValue + ", ";
        }
        filterValue = filterValue + value;
      }
    } else {
      filterValue = values;
    }
    return filterValue;
  };

  const normalizeIdValue = (value) => {
    if (value === undefined || value === null) return null;
    const trimmed = String(value).trim();
    return trimmed.length ? trimmed : null;
  };

  const getPatientBaseIdentifier = (patient) => {
    if (!patient) return null;
    return (
      normalizeIdValue(patient.id) ??
      normalizeIdValue(patient.patientId) ??
      normalizeIdValue(patient.patientID) ??
      normalizeIdValue(patient.memberId) ??
      null
    );
  };

  const getPatientVisitIdentifier = (patient) => {
    if (!patient) return null;
    return (
      normalizeIdValue(patient.worklistItemId) ??
      normalizeIdValue(patient.worklistItemID) ??
      normalizeIdValue(patient.patientGapId) ??
      normalizeIdValue(patient.patientGapID) ??
      normalizeIdValue(patient.careGapId) ??
      normalizeIdValue(patient.careGapID) ??
      normalizeIdValue(patient.visitGapId) ??
      normalizeIdValue(patient.visitGapID) ??
      normalizeIdValue(patient.visitId) ??
      normalizeIdValue(patient.visitID) ??
      null
    );
  };

  const forEachPatient = (patientsCollection, callback) => {
    if (typeof patientsCollection?.forEach === "function") {
      patientsCollection.forEach(callback);
    }
  };

  const buildSelectedItemIdentifiers = (patientsCollection = selectedPatients) => {
    const baseIdentifiers = new Set();
    const fallbackIdentifiers = new Set();

    const addPatient = (patient) => {
      if (!patient) return;
      const baseId = getPatientBaseIdentifier(patient);
      if (baseId) {
        baseIdentifiers.add(baseId);
        return;
      }
      const visitId = getPatientVisitIdentifier(patient);
      if (visitId) {
        fallbackIdentifiers.add(visitId);
      }
    };

    forEachPatient(patientsCollection, addPatient);

    return [...baseIdentifiers, ...fallbackIdentifiers];
  };

  const buildUniquePatientIds = (patientsCollection = selectedPatients) => {
    const uniqueIds = new Set();

    const addPatientId = (patient) => {
      if (!patient) return;
      const baseId = getPatientBaseIdentifier(patient);
      if (baseId) {
        uniqueIds.add(baseId);
        return;
      }
      const fallbackId = normalizeIdValue(patient?.id);
      if (fallbackId) {
        uniqueIds.add(fallbackId);
      }
    };

    forEachPatient(patientsCollection, addPatientId);

    return Array.from(uniqueIds);
  };

  const print = (alreadyAddedPatients) => {
    setShowPrintSpinner(true);
    const filterData = new PatientSearchDTO(
      filterParams,
      sortParams,
      pageNumber,
      pageSize,
      quickListType
    );

    let criteria = {};
    criteria.patientRequest = filterData;
    criteria.selectedItems = [];
    if (selectedPatients.size) {
      criteria.selectedItems = buildSelectedItemIdentifiers();
    } else if (alreadyAddedPatients?.length && !selectedPatients.size) {
      criteria.selectedItems = alreadyAddedPatients;
    } else {
      criteria.selectedItems = buildSelectedItemIdentifiers(patientsList.default);
    }
    criteria.quickList = quickListType;
    trackPendoEvent(TRACK_EVENTS.QUICKLIST_PRINT_SUBMIT, {
      route: globalThis.location?.pathname,
      quicklist_type: quickListType,
      row_scope: selectedPatients.size ? "selected" : "filtered",
      source_module: "QuickListNew.print"
    });
    axios
      .post(PRINT_URL, criteria, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        summary();
      })
      .catch((error) => {
        trackPendoEvent(TRACK_EVENTS.QUICKLIST_PRINT_SUBMIT, {
          route: globalThis.location?.pathname,
          quicklist_type: quickListType,
          row_scope: selectedPatients.size ? "selected" : "filtered",
          source_module: "QuickListNew.print",
          success: false,
          error_code: getErrorCode(error, "quicklist_print_failed")
        });
        setShowPrintSpinner(false);
        setModalTitle("Error");
        setModalMessage(error.response.data.message);
      });
  };

  const summary = () => {
    axios
      .get(SUMMARY_URL, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setShowPrintSpinner(false);
        setShowExportSpinner(false);
        setModalTitle("Export Summary");
        setModalSize("lg");
        setModalMessage(<ExportSummary exportSummary={response.data} />);
      })
      .catch((error) => {
        setShowPrintSpinner(false);
        setShowExportSpinner(false);
        setModalTitle("Error");
        setModalMessage(error.response.data.message);
        setLoadingData(false);
      });
  };

  const renderNoPatients = () => {
    if (loadingData || listViewLoadingData) {
      return null;
    }

    return (
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Card.Text id={`${componentName}-NoPatients`}>
                {canceled ? 'Loading...' : 'No Patients Found'}
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  const renderPatientList = () => {
    if (patientsList.default?.length > 0 && patientsList.default[0] !== "Empty") {
      return (
        <ListView
          updatePatients={setPatientsList}
          patientList={patientsList}
          quickListType={quickListType}
          workListStatusSize={[scheduledPatientSize, unScheduledPatientSize, unableToContactPatientSize, patientRefusedPatientSize, leftMessagePatientSize, changedPCPPatientSize]}
          loadingData={loadingData}
          listViewLoadingData={listViewLoadingData}
          handleChangeCheckBox={selectPatient}
          handleAllPatientsCheckbox={selectPatients}
          isPatientSelected={isPatientSelected}
          quicklistId={quicklistId}
          returnToMyPatientsUrl={returnToMyPatientsUrl}
          updateParent={updateParent}
          closeEvidenceModal={closeEvidenceModal}
          reloadPatientView={reloadPatientView}
          onShowAssignCareManagerModal={onShowAssignCareManagerModal}
          careManagementActions={careManagementActions}
          titleProp={titleProp}
          handleFilterChange={handleFilterChange}
          filterParams={filterParams}
          pageNumber={pageNumber}
        />
      );
    }

    if (weekFilterApplied && !isEmpty(patientsList.weekView)) {
      return (
        <ScheduleListView
          updatePatients={setPatientsList}
          patientList={patientsList.weekView}
          quickListType={quickListType}
          loadingData={loadingData}
          listViewLoadingData={listViewLoadingData}
          handleChangeCheckBox={selectPatient}
          handleAllPatientsCheckbox={selectPatients}
          isPatientSelected={isPatientSelected}
          quicklistId={quicklistId}
          returnToMyPatientsUrl={returnToMyPatientsUrl}
          updateParent={updateParent}
          closeEvidenceModal={closeEvidenceModal}
          reloadPatientView={reloadPatientView}
          onShowAssignCareManagerModal={onShowAssignCareManagerModal}
          careManagementActions={careManagementActions}
          titleProp={titleProp}
          handleFilterChange={handleFilterChange}
          filterParams={filterParams}
          pageNumber={pageNumber}
          print={print}
          handleFilterDatesResult={handleFilterDatesResult}
        />
      );
    }

    return renderNoPatients();
  };


  return (
    <Container fluid className="py-3">
      <Helmet>
        <title>{title} | CareEmpower</title>
      </Helmet>
      <Modals
        show={removeModal}
        onHide={() => setRemoveModal(false)}
        title="Remove Member(s) from organization's patient list"
        size="lg"
        onCreate={removePatients}
        hideClickButton={false}
        showExtraButton={false}
        hideFooter={false}
        completeBtn="Save"
        completeBtnId={`${componentName}-saveButton`}
        body={
          <RemoveModalBody
            patientsSelected={Array.from(
              selectedPatients,
              ([key, value]) => value
            )}
          />
        }
      />
      {quicklistId && !Number.isNaN(Number(quicklistId)) ?
        <ShareWorklist
          shareModal={shareModal}
          setShareModal={setShareModal}
          setModalMessage={setModalMessage}
          setModalSize={setModalSize}
          setModalTitle={setModalTitle}
          customListDto={customListDto}
          setCustomListDto={setCustomListDto}
          quicklistId={quicklistId}
          customWorklistName={customWorklistName}
        /> : ''}
      <ConfirmWorklistDeletion
          showConfirmation={showDeleteConfirmation}
          setConfirmation={setShowDeleteConfirmation}
          id={quicklistId}
          customListDto={customListDto}
      />
      <Row className="mb-3">
        <Col>
          <Row>
            <Col className="d-flex justify-content-between">
              <div>
                <FilterGroupNew
                  filters={filters}
                  handleChange={handleFilterChange}
                  defaultFilterParams={defaultFilterParams}
                  filterParams={filterParams}
                  customWorklistName={customWorklistName}
                  additionalValidation={
                    qlsSettings.additionalFilterValidation
                  }
                  setScheduleFilterApplied={setScheduleFilterApplied}

                />
              </div>
              <div className="">
                {!scheduleFilterApplied && (<WeekFilter
                  setFilterDates={setFilterDates}
                  filterDates={filterDates}
                  setWeekFilterApplied={setWeekFilterApplied}
                  loading={loadingData || listViewLoadingData || canceled}
                  resetDefault={resetDefault}
                />)}
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm={5} md={4} className="d-flex align-items-end">
              {!isEmpty(totalSize) && !weekFilterApplied && !scheduleFilterApplied && (
                <div className="d-flex flex-column">
                  <small id={`${componentName}-MonthandDay`}>{new Date().toLocaleDateString(undefined, { month: 'long', day: 'numeric' })}</small>
                  <h5 className="mb-0">
                    <span id={`${componentName}-DayoftheWeek`} className="me-2">Today</span>
                    <Badge pill id={`${componentName}-PatientCount`} className="bg-primary">
                      {totalSize.toLocaleString()}
                    </Badge>
                  </h5>
                </div>
              )}
              {!isEmpty(totalSize) && scheduleFilterApplied && (
                <div className="d-flex flex-column">
                  <h5 className="mb-0 d-flex align-items-center">
                    <span id={`${componentName}-filteredResults`} className="me-2">Filtered Results</span>
                    <Badge pill id={`${componentName}-PatientCount`} className="bg-primary">
                      {totalSize.toLocaleString()}
                    </Badge>
                  </h5>
                </div>
              )}
              {quickListId && quickListId === "REFERRALS_CARE_MANAGEMENT" && (
                <DropdownButton
                  id={`${componentName}-actionsBtn`}
                  disabled={selectedPatients.size < 2}
                  size="sm"
                  variant="outline-secondary"
                  className="d-inline-block bg-white align-top me-2"
                  title="Bulk Actions"
                >
                  {careManagementActions?.map((action, idx) => (
                    <Dropdown.Item id={`${componentName}-actionsBtnItems-${idx}`} key={`${componentName}-${action.value}-${idx}-key`}
                      onClick={() => bulkCareManagerAssignment()}>{action.text}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
              )}
              {children}
              {(loadingData || listViewLoadingData || canceled) && (
                <Spinner
                  className="align-middle mb-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
            </Col>
            <Col className="d-flex align-items-end justify-content-start justify-content-sm-end mt-sm-0">
              {(showExportSpinner || showPrintSpinner) && (
                <Spinner
                  className="align-middle mb-4"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {(!weekFilterApplied) && (<div className="d-inline-block mx-2 align-top">
                <select className="form-select" id={`${componentName}-ResultsPerPage`} value={`${pageSize}-Results`} onChange={(e) => handleFilterPageSize(e)}>
                  <option value="20-Results">20 Results Per Page</option>
                  <option value="50-Results">50 Results Per Page</option>
                </select>
              </div>)}
              {!weekFilterApplied && (
                <Button onClick={() => print()}
                  disabled={loadingData || listViewLoadingData || canceled} variant="secondary" id={`${componentName}-patientChartPrepTool`} className="border">
                  Print Chart Prep Tool
                </Button>)}
              {((!isEmpty(patientsList.default)) || (!isEmpty(patientsList.weekView) && (totalSize !== 0)))
                && (<div className="d-inline-block ms-0 ms-sm-2">
                  <CustomPagination
                    paginateButClicked={handlePaginationChange}
                    MAX_PAGE={Math.ceil(totalSize / pageSize)}
                    pageNumber={Math.ceil(pageNumber)}
                  />
                </div>)}
              {filterButtons && (
                <>
                  <Button variant="secondary" size="sm" className="align-top border me-2" id={`${componentName}-Delete`} onClick={() => setShowDeleteConfirmation(true)}>
                    Delete
                  </Button>
                  <Button variant="secondary" size="sm" className="align-top border me-2" id={`${componentName}-Update`} onClick={() => setShowUpdateCustomFilterList(true)}>
                    Update
                  </Button>
                </>
              )}
            </Col>
          </Row>
          {!isEmpty(patientsList.default) && showCount && (
            <Row className="mx-2">
              <Col className="text-primary">
                {totalSize} Members Listed
              </Col>
            </Row>
          )}
        </Col>
      </Row>
      {renderPatientList()}
      <CustomFilterList
        filters={getCurrentFilters()}
        showCustomFilterList={showCustomFilterList}
        setShowCustomFilterList={setShowCustomFilterList}
        filterParams={filterParams}
        sortParams={sortParams}
        pageNumber={pageNumber}
        pageSize={pageSize}
        quickList={quickListType}
        setModalMessage={setModalMessage}
        setModalSize={setModalSize}
        setModalTitle={setModalTitle}
      />
      <UpdateCustomFilterList
          id={quicklistId}
          filters={getCurrentFilters()}
          showUpdateCustomFilterList={showUpdateCustomFilterList}
          setShowUpdateCustomFilterList={setShowUpdateCustomFilterList}
          filterParams={filterParams}
          setModalMessage={setModalMessage}
          setModalSize={setModalSize}
          setModalTitle={setModalTitle}
      />
      <Modals
        show={modalMessage != null}
        onHide={() => setModalMessage(null)}
        title={modalTitle}
        size={modalSize || "md"}
        hideClickButton={true}
        showExtraButton={false}
        hideFooter={false}
        closeBtnId={`${componentName}-closeButton`}
        body={modalMessage}
      />
      <AssignCareManagerModal
        show={showAssignCareManagerModal}
        teams={careManagerTeams}
        programs={careManagerPrograms}
        onAssign={assignToCareManager}
        onClose={() => setShowAssignCareManagerModal(false)}
        onError={onCareManagerAssigmentError}
        selectedName={selectedName}
      />
    </Container>
  );
};

QuickListNew.propTypes = {
  titleProp: PropTypes.string,
  filters: PropTypes.array,
  pageNumberProp: PropTypes.number,
  pageSizeProp: PropTypes.number,
  totalSizeProp: PropTypes.number,
  defaultFilterParamsProp: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  defaultSortParamsProp: PropTypes.array,
  quickListType: PropTypes.string,
  displayExtraRows: PropTypes.bool,
  quickListId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cardViewActionObj: PropTypes.shape({
    fetchData: PropTypes.func,
    copyMap: PropTypes.object,
  }),
  listViewActionObj: PropTypes.shape({
    fetchData: PropTypes.func,
    copyMap: PropTypes.object,
  }),
  startingView: PropTypes.string,
  listViewColumns: PropTypes.array,
  children: PropTypes.node,
  careManagementActions: PropTypes.array,
  onCareManagerAssigmentError: PropTypes.func,
  careManagerPrograms: PropTypes.array,
  careManagerTeams: PropTypes.array,
  showCount: PropTypes.bool,
};

export { QuickListNew, VIEW, LAST_QUERY_SETTINGS_SUFFIX, RECENT_QUERY_SETTINGS_KEY };
